import { GET_MEDIA_REQUEST, GET_MEDIA_REQUEST_SUCCESS, GET_MEDIA_REQUEST_ERROR } from '../types/media';

export const getMedia = (mediaId: number) => ({
  type: GET_MEDIA_REQUEST,
  payload: mediaId
});

export const getMediaSuccess = (data: any) => ({
  type: GET_MEDIA_REQUEST_SUCCESS,
  payload: data
});

export const getMediaFailure = (error: string) => ({
  type: GET_MEDIA_REQUEST_ERROR,
  payload: error
});
